import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import CoordinatesSchema, { 
  CoordinatesParams, 
  CoordinatesJSON 
} from "_shared/addresses/coordinates/coordinates-schema";

export default class Coordinates {
  public static readonly EXAMPLE: Coordinates = Coordinates.create({
    latitude: "37.7749",
    longitude: "-122.4194"
  });

  public static create(values: CoordinatesParams): Coordinates {
    const parsed = CoordinatesSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid Coordinates parameters.");
    }
    return new Coordinates(parsed);
  }

  public static fromJSON(json: CoordinatesJSON): Coordinates {
    if (isNullOrUndefined(json)) return json;
    const params = CoordinatesSchema.deserialize(json);
    return new Coordinates(params);
  }

  public readonly latitude: string;
  public readonly longitude: string;

  public constructor(params: CoordinatesParams) {
    this.latitude = params.latitude;
    this.longitude = params.longitude;
  }

  public toJSON(): CoordinatesJSON {
    return CoordinatesSchema.serialize(this);
  }

  public isEqualTo(other: Coordinates | null | undefined): boolean {
    if (!other) return false;
    return this.latitude === other.latitude && this.longitude === other.longitude;
  }

  public toString(): string {
    return `Coordinates (
      latitude: ${this.latitude}
      longitude: ${this.longitude}
    )`;
  }
}
